import { setTerm } from './helpers';

export const setWithNeighbors = setTerm('with_neighbors');
